<template>
  <el-popover
    placement="left-end"
    trigger="hover"
    :visible-arrow="false">
    <router-link to="/help" class="version-explain">更新说明</router-link>
    <div>
      <p class="info">学校开课请联系刘老师：177-2471-3059<i class="wechat-icon" @mouseenter="showQRCode1 = true" @mouseleave="showQRCode1 = false"></i></p>
      <div :class="`${showQRCode1 && 'show'} img-wrap`">
        <img src="~@/assets/image/qr1.png" alt="">
      </div>
      <p class="info">机构开课请联系商务喵：189-2462-9926<br>（已合作机构请联系各自教练）<i class="wechat-icon" @mouseenter="showQRCode2 = true" @mouseleave="showQRCode2 = false"></i></p>
      <div :class="`${showQRCode2 && 'show'} img-wrap`">
        <img src="https://public-static-edu.codemao.cn/redboat/static/qr2.png" alt="">
      </div>
      <p class="info">点猫编程平台产品经理QQ：2132425655</p>
      <p class="info">商务合作与课程咨询：189-2462-9926</p>
      <p class="info" v-if="role_id !== 20001">点猫校园编程公众号：codemao8<i class="wechat-icon" @mouseenter="showQRCode3 = true" @mouseleave="showQRCode3 = false"></i></p>
      <div :class="`${showQRCode3 && 'show'} img-wrap`">
        <img src="https://public-static-edu.codemao.cn/redboat/static/qr3.png" alt="">
      </div>
    </div>
    <div class="flex" style="padding-top:10px">
      <el-button @click="view" size="mini">常见问题及使用指南</el-button>
      <el-button @click="showGuide" size="mini">操作指引</el-button>
    </div>
    <div class="container" slot="reference">
      <span class="codemao"></span>
      <span class="word">帮助&反馈</span>
    </div>
  </el-popover>
</template>

<script>
export default {
  data () {
    return {
      showQRCode1: false,
      showQRCode2: false,
      showQRCode3: false
    }
  },
  computed: {
    role_id() {
      return this.$store.state.user.role_id
    }
  },
  methods: {
    view() {
      switch (this.role_id) {
        case 10001: // 教官
          window.open('/docs/master/')
          break
        case 10002: // 教师
          window.open('/docs/teacher/')
          break
        case 20001: // 学生
          window.open('/docs/student/')
          break
      }
    },
    showGuide() {
      this.$store.commit('setState', {
        module: 'base',
        key: 'playGuide',
        value: true
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.version-explain {
  display: block;
  color: #02C4AA;
  margin-bottom: 20px;
}
.info {
  color: #333;
  line-height: 17px;
  margin-bottom: 10px;
  display: flex;
  .wechat-icon {
    width: 17px;
    height: 17px;
    display: inline-block;
    background: url('https://education.codemao.cn/27/public-edu/1/wechat@2x.png') center / cover no-repeat;
    margin-left: 6px;
    cursor: pointer;
    &:hover {
      background: url('https://education.codemao.cn/27/public-edu/1/wechat-active@2x.png') center / cover no-repeat;

    }
  }
}
.img-wrap {
  display: flex;
  justify-content: center;
  transition: all .3s;
  height: 0;
  visibility: hidden;
  box-sizing: content-box;
  &.show {
    visibility: visible;
    height: 80px;
    padding: 10px 0 15px;
    img {
      opacity: 1;
    }
  }
  img {
    width: 80px;
    height: 80px;
    opacity: 0;
    transition: all .3s;
  }
}
.container {
  position: fixed;
  bottom: 100px;
  right: 15px;
  z-index: 999;
  width: 32px;
  height: 90px;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(37, 110, 100, .3);
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 12px;
  &:hover {
    .word {
      color: #FFA21C;
    }
  }
  .codemao {
    width: 32px;
    height: 28px;
    position: absolute;
    top: -28px;
    left: 0;
    background: url('https://education.codemao.cn/27/public-edu/1/codemao.gif') center / cover no-repeat;
  }
  .word {
    display: inline-block;
    width: 15px;
    font-size: 12px;
    color: #999;
    line-height: 15px;
    text-align: center;
  }
}
</style>
